export default __webpack_public_path__ + "static/media/product-arrow2.ec177b2a.svg";